var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocuri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_119",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500854,
    y: 0.272949,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5009 12.2729C13.0509 12.2729 13.5217 12.0771 13.9134 11.6854C14.305 11.2938 14.5009 10.8229 14.5009 10.2729C14.5009 9.72295 14.305 9.25212 13.9134 8.86045C13.5217 8.46878 13.0509 8.27295 12.5009 8.27295C11.9509 8.27295 11.48 8.46878 11.0884 8.86045C10.6967 9.25212 10.5009 9.72295 10.5009 10.2729C10.5009 10.8229 10.6967 11.2938 11.0884 11.6854C11.48 12.0771 11.9509 12.2729 12.5009 12.2729ZM12.5009 19.6229C14.5342 17.7563 16.0425 16.0604 17.0259 14.5354C18.0092 13.0104 18.5009 11.6563 18.5009 10.4729C18.5009 8.65628 17.9217 7.16878 16.7634 6.01045C15.605 4.85212 14.1842 4.27295 12.5009 4.27295C10.8175 4.27295 9.39669 4.85212 8.23835 6.01045C7.08002 7.16878 6.50085 8.65628 6.50085 10.4729C6.50085 11.6563 6.99252 13.0104 7.97585 14.5354C8.95919 16.0604 10.4675 17.7563 12.5009 19.6229ZM12.5009 21.8979C12.3675 21.8979 12.2342 21.8729 12.1009 21.823C11.9675 21.773 11.8509 21.7063 11.7509 21.6229C9.31752 19.4729 7.50085 17.4771 6.30085 15.6354C5.10085 13.7938 4.50085 12.0729 4.50085 10.4729C4.50085 7.97295 5.30502 5.98128 6.91335 4.49795C8.52169 3.01462 10.3842 2.27295 12.5009 2.27295C14.6175 2.27295 16.48 3.01462 18.0884 4.49795C19.6967 5.98128 20.5009 7.97295 20.5009 10.4729C20.5009 12.0729 19.9009 13.7938 18.7009 15.6354C17.5009 17.4771 15.6842 19.4729 13.2509 21.6229C13.1509 21.7063 13.0342 21.773 12.9009 21.823C12.7675 21.8729 12.6342 21.8979 12.5009 21.8979Z",
    fill: "#7E8488"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocuri);
export default __webpack_public_path__ + "static/media/icon_locuri.107a0c701214d8c6cba0f9c110279acd.svg";
export { ForwardRef as ReactComponent };